export default __webpack_public_path__ + "static/media/IMG6.878011c8.JPG";